import { render } from "./13ContactSection.vue?vue&type=template&id=4f337c72&scoped=true"
import script from "./13ContactSection.vue?vue&type=script&lang=js"
export * from "./13ContactSection.vue?vue&type=script&lang=js"

import "./13ContactSection.vue?vue&type=style&index=0&id=4f337c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f337c72"]])

export default __exports__